import { type AppConfig, useAppConfig } from "@/vf"
import type { OrderTransition } from "@/model/order-transition"
import type { Login } from "@/model/backend/login"

export type AcpRole =
    | "ROLE_ADMIN"
    | "ROLE_DELETE_ORDER"
    | "ROLE_MANAGE_BLACKLIST"
    | "ROLE_DELETE_CUSTOMER"
    | "ROLE_EDIT_DOCTOR_QUESTIONNAIRE"
    | "ROLE_CREATE_DOCTOR_QUESTIONNAIRE"
    | "ROLE_DELETE_DOCTOR_QUESTIONNAIRE"
    | "ROLE_RESEND_DOCTOR_QUESTIONNAIRE"
    | "ROLE_APPROVE_DOCTOR_QUESTIONNAIRE"
    | "ROLE_REJECT_DOCTOR_QUESTIONNAIRE"
    | "ROLE_MANAGE_DOCTOR"
    | "ROLE_MANAGE_JOB_OFFERS"
    | "ROLE_MANAGE_ARTICLE"
    | "ROLE_DELETE_ARTICLE"
    | "ROLE_MANAGE_ARTICLE_ARCHIVE"
    | "ROLE_CREATE_DOCTOR"
    | "ROLE_EDIT_DOCTOR"
    | "ROLE_DELETE_DOCTOR"
    | "ROLE_DEVELOPER"
    | "ROLE_LICENSED_PHARMACIST"
    | "ROLE_CHANGE_BATCH_PREPARATION_STOCK"
    | "ROLE_EDIT_BATCH_PREPARATION"
    | "ROLE_UNDO_MANUFACTURED"
    | "ROLE_MANAGE_SALES_LIST"

export type AcpAppConfig = AppConfig & {
    roles: Record<AcpRole, boolean>
    assignableRoles: Array<{ role: AcpRole; label: string; granted: boolean }>
    allowedOrderTransitions: Record<OrderTransition, boolean>
    login: Login
    shopUrl: string
}

export function useAcpAppConfig() {
    return useAppConfig<AcpAppConfig>()
}
